import { render, staticRenderFns } from "./BuyerActivitySection.vue?vue&type=template&id=7611cfe0&scoped=true"
import script from "./BuyerActivitySection.vue?vue&type=script&lang=js"
export * from "./BuyerActivitySection.vue?vue&type=script&lang=js"
import style0 from "./BuyerActivitySection.vue?vue&type=style&index=0&id=7611cfe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7611cfe0",
  null
  
)

export default component.exports